module.exports = {"validation":{"required":"Acest câmp este obligatoriu","email":"Adresă de e-mail invalidă"}}